import translations from '../translations';

export const TRACE_ID_HEADER = 'X-Trace-Id';

/**
 * An error returned by the engine API, carrying the trace ID of the request so it can be reported to support
 */
export class ApiError extends Error {
    traceId: string | null;

    constructor(message: string, traceId: string | null, options?: ErrorOptions) {
        super(message, options);
        this.name = 'ApiError';
        this.traceId = traceId;
    }
}

export const tryGetErrorMessage = (error: unknown) => {
    return error instanceof Error
        ? error.message
        : typeof error === 'string'
          ? error
          : translations.USER_SETTINGS_unknown_error_message;
};

export const tryGetTraceId = (error: unknown) => {
    return error instanceof ApiError ? error.traceId : null;
};
